import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Switch, Route } from 'react-router-dom';
import { AdmsRepository } from '../../redux/AdmsActions';
import {AssetListView, AssetCardView, EMDCardView, XSDViewer, IEPCardView, LinkerViewer} from '../../views/containers'
import { LoadingComponent, ErrorMessageComponent } from '../../utils/ui'
import {PromiseSequenceRunner} from '../../utils/promiseUtil'
import { factory } from '../../components/adms/Providers'
import { Modal } from 'antd';
import LinkerActions from '../../redux/LinkerActions';

/** Окно для установки связи с выбранном элементом  */
const showViewLinker = (factory, onFinishOperation=f=>f, onCancelOperation=f=>f) => {
	//console.log("syncPercent", syncPercent);
	return <Modal style={{minWidth: "80%"}} visible={true} title="Установка связи " cancelText="Отмена" okText="Связать" 
		onCancel={onCancelOperation} onOk={onFinishOperation}>
        <LinkerViewer factory={factory} />
	  </Modal>
}

/** Панель ADMS каталога. Перед отображдением загружает:
 *  1. Онтологию ADMS-WF
 *  2. Таксономию каталога
 *  3. Параметры визуализации активов
 */
class ADMSPanel extends React.Component {
  
  state = {
    loading: false,
    linker: undefined,    //Флаг, что должен отображаться диалог назначения связи
    error: undefined,
  }
  
  static getDerivedStateFromProps(props, state) {
    //console.log("ADMSPanel.js static getDerivedStateFromProps", props, state);
    if (props.linker && (props.linker.state=="show")){
        return { ...state, linker: true}
    } 
    if (state.linker)
      return { ...state, linker: false}
    return null; // Return null to indicate no change to state.
  }

  componentDidMount() {
    this.loadAdmsOntology()
  }

  loadAdmsOntology() {
    this.setState({loading: true})
    return PromiseSequenceRunner([ //Promise.all
      //Загрузим описание
      this.props.dispatch(AdmsRepository.loadThemeTaxonomy()),
      //Снять обязательный фильтр (если он есть)
      this.props.dispatch(AdmsRepository.SET_RFILTER([]))
    ])
    .then ((response) =>{
      this.setState({loading: false, error: undefined});
    })
    .catch(e => { 
      this.setState({loading: false, error: e});
    });
  }
    
  cancelOperation(){
		this.props.dispatch(LinkerActions.EMPTY());
//    this.setState({linker: undefined});
  }

  render() {
    //console.log(this);
    const { loading, linker } = this.state;
    return (
        (loading? 
          <LoadingComponent />:
          <span>
            <Switch>
              <Route path="/adms/:id" render = {(params) => <AssetCardView factory={factory} />}></Route>            
              <Route path="/viewemd/:id" render = {(params) => <EMDCardView factory={factory} />}></Route>
              <Route path="/vieweip/:id" render = {(params) => <IEPCardView factory={factory} />}></Route>
              <Route path="/xsd/:id" render = {(params) => <XSDViewer factory={factory} />}></Route>            
              <Route path="*" render={()=> <AssetListView factory={factory}  />}></Route>
            </Switch>
            {linker && showViewLinker(factory, ()=>this.cancelOperation(), ()=>this.cancelOperation())}            
          </span>
        )
    );
  }
}
  
function mapStateToProps(state, props) {
  //console.log("ADMSPanel.js function mapStateToProps(state, props)", state, props);
  const { vset, linker } = state;
  const { graph, lang } = props;
  return {
    graph: (graph)?graph: vset.graph,
    lang: (lang)?lang: vset.lang,
    linker
  };
}

export default withRouter(connect(mapStateToProps)(ADMSPanel));
